import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import CampaignDto from '@/models/Campaigns/CampaignDto';
import NoteDto from '@/models/Notes/NoteDto';
import UpdateNoteRequest from '@/models/Notes/UpdateNoteRequest';
import CreateNoteRequest from '@/models/Notes/CreateNoteRequest';
import UpdateCampaignGeneralDetailsRequest from '@/models/Campaigns/UpdateCampaignGeneralDetailsRequest';
//import CampaignBrowseContactsViewModel from '@/models/CampaignContacts/CampaignBrowseContactsViewModel';
import ContactSearchViewModel from '@/models/Contacts/ContactSearchViewModel';
import ContactProfileSearchRequest from '@/models/Contacts/ContactProfileSearchRequest';
import WorkType from '@/models/Shared/WorkType';
import ContactProfileDto from '@/models/Contacts/ContactProfileDto';
import SelectableEntity from '@/models/Shared/SelectableEntity';
import DistanceViewModel from '@/models/Shared/DistanceViewModel';
//import ContactSearchOptionsResponse from '@/models/Contacts/ContactSearchOptionsResponse';
//import CreateCampaignContactsRequest from '@/models/CampaignContacts/SendCampaignToContactsRequest';
import CampaignContactDto from '@/models/CampaignContacts/CampaignContactDto';
//import CampaignContactsViewModel from '@/models/CampaignContacts/CampaignContactsViewModel';

import UpdateCampaignStatusRequest from '@/models/Campaigns/UpdateCampaignStatusRequest';


import UpdateCampaignEmailDetailsRequest from '@/models/Campaigns/UpdateCampaignEmailDetailsRequest';
import CampaignBrowseContactsViewModel from '@/models/CampaignContacts/CampaignBrowseContactsViewModel';
import ContactStatus from '@/models/Contacts/ContactStatus';
import LocationTypeDto from '@/models/LocationTypes/LocationTypeDto';
import PositionDto from '@/models/Positions/PositionDto';
import CreateCampaignContactsRequest from '@/models/CampaignContacts/CreateCampaignContactsRequest';
import CampaignContactsViewModel from '@/models/Campaigns/CampaignContactsViewModel';
import NoteCategoryDto from '@/models/NoteCategories/NoteCategoryDto';
import CampaignEmailPreviewResponse from '@/models/CampaignContacts/CampaignEmailPreviewResponse';
import OpportunityDto from '@/models/Opportunities/OpportunityDto';
import OpportunityStatus from '@/models/Opportunities/OpportunityStatus';
import OpportunityStage from '@/models/Opportunities/OpportunityStage';
import CampaignOpportunityDto from '@/models/CampaignOpportunities/CampaignOpportunityDto';
import CreateCampaignOpportunitiesRequest from '@/models/CampaignOpportunities/CreateCampaignOpportunitiesRequest';
import CampaignBrowseOpportunitiesViewModel from '@/models/CampaignOpportunities/CampaignBrowseOpportunitiesViewModel';
import CampaignOpportunitiesViewModel from '@/models/CampaignOpportunities/CampaignOpportunitiesViewModel';
import CampaignOpportunitySearchViewModel from '@/models/CampaignOpportunities/CampaignOpportunitySearchViewModel';

export interface ICampaignDetailsState {
  loading: boolean;
  loadingContact: boolean;
  loadingContacts: boolean;
  loadingDialog: boolean;
  notes: NoteDto[];
  noteCategories: NoteCategoryDto[];
  loadingNotes: boolean;
  currentCampaign: CampaignDto | null; 
  browseContactsVM: CampaignBrowseContactsViewModel;
  contactSearchViewModel: ContactSearchViewModel;
  campaignContactsVM: CampaignContactsViewModel;
  loadingOpportunities: boolean;
  browseOpportunitiesVM: CampaignBrowseOpportunitiesViewModel;
  opportunitySearchViewModel: CampaignOpportunitySearchViewModel;
  campaignOpportunitiesVM: CampaignOpportunitiesViewModel;
}

@Module({ dynamic: true, store, name: 'CampaignDetails', namespaced: true})
class CampaignDetails extends VuexModule implements ICampaignDetailsState {
  
  public loading = false;
  public loadingContact = false; 
  public loadingContacts = true; 
  public loadingNotes = true;
  public loadingDialog = false;
  public notes: NoteDto[] = [];
  public noteCategories: NoteCategoryDto[] = [];
  public currentCampaign: CampaignDto = new CampaignDto();
  public browseContactsVM: CampaignBrowseContactsViewModel = new CampaignBrowseContactsViewModel();
  public contactSearchViewModel: ContactSearchViewModel = new ContactSearchViewModel();
  public campaignContactsVM: CampaignContactsViewModel = new CampaignContactsViewModel();
  public loadingOpportunities = true;
  public browseOpportunitiesVM: CampaignBrowseOpportunitiesViewModel = new CampaignBrowseOpportunitiesViewModel();
  public opportunitySearchViewModel: CampaignOpportunitySearchViewModel = new CampaignOpportunitySearchViewModel();
  public campaignOpportunitiesVM: CampaignOpportunitiesViewModel = new CampaignOpportunitiesViewModel();

  @Action
  public async getCampaign(campaignId: string) {
    this.setLoading(true);
    await ajax.get(`/api/v1/agency/campaigns/${campaignId}`)
    .then(response => {
      this.context.commit("setCurrentCampaign", response.data);
      this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }

  @Action
  public async editCampaignGeneralDetails(request: UpdateCampaignGeneralDetailsRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/campaigns/${this.currentCampaign.id}/general-details`, request)
    .then(response => {
      this.context.commit("setCurrentCampaignGeneralDetailsFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  public async editCampaignEmailDetails(request: UpdateCampaignEmailDetailsRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/campaigns/${this.currentCampaign.id}/email-details`, request)
    .then(response => {
      this.context.commit("setCurrentCampaignEmailDetailsFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  public async updateCampaignStatus(request: UpdateCampaignStatusRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/campaigns/${this.currentCampaign.id}/status`, request)
    .then(response => {
      this.context.commit("setCurrentCampaignStatusFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async getNoteCategories() {
    //this.setLoadingNotes(true);
    await ajax.get(`/api/v1/agency/note-categories?entityType=300`)
    .then(response => {
      this.context.commit("setNoteCategories", response.data);
      //this.setLoadingNotes(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      //this.setLoadingNotes(false);
    });
  }

  @Action
  async getNotes() {
    this.setLoadingNotes(true);
    await ajax.get(`/api/v1/agency/campaigns/${this.currentCampaign.id}/notes`)
    .then(response => {
      this.context.commit("setNotes", response.data);
      this.setLoadingNotes(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingNotes(false);
    });
  }

  @Action
  async createNote(request: CreateNoteRequest) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/campaigns/${this.currentCampaign.id}/notes`, request)
    .then(response => {
      this.context.commit("setNoteFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async editNote(note: NoteDto) {
    const request = new UpdateNoteRequest();
    request.updatedAt = note.updatedAt
    request.description = note.description;
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/campaigns/${this.currentCampaign.id}/notes/${note.id}`, request)
    .then(response => {
      this.context.commit("setNoteFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async testCampaignContactEmail() {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/campaigns/${this.currentCampaign.id}/contacts/${this.campaignContactsVM.selectedCampaignContact.id}/test`, null)
    .then(response => {
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async previewCampaignContactEmail(): Promise<CampaignEmailPreviewResponse | null> {
    this.setLoadingDialog(true);
    try {
      const response = await ajax.get(`/api/v1/agency/campaigns/${this.currentCampaign.id}/contacts/${this.campaignContactsVM.selectedCampaignContact.id}/preview`);
      this.setLoadingDialog(false);
      return response.data as CampaignEmailPreviewResponse;
    } catch (error) {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
      return null;
    }
  }

  @Action
  async sendEmailCampaign() {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/campaigns/${this.currentCampaign.id}/send`, null)
    .then(response => {
      this.context.commit("setCurrentCampaignStatusFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action 
  async resetAdvancedContactSearch(){
    this.context.commit("setBrowseContactsVM");
  }

  @Action 
  async browseDefaultContactSearch() {
   
    //Refresh the current campaign requirements
    this.context.commit("setBrowseContactsVM");
    
    this.setLoadingContacts(true);
    const request = new ContactProfileSearchRequest();
    request.status = ContactStatus.Active;
    request.isAgreedToMarketing = true;

    //Location Types
    request.locationTypeIds = this.contactSearchViewModel.selectedLocationTypes.map(function(locationType: LocationTypeDto) {
      return locationType.id;
    });

    //Positions
    request.positionCodes = this.contactSearchViewModel.selectedPositions.map(function(position: PositionDto) {
         return position.code;
    });
 

    if (this.currentCampaign.branch !== null) {
      request.distance = this.contactSearchViewModel.selectedDistance.value
      if (request.distance != 0) {
        //Fetch lat and long
        request.latitude = CampaignDetailsModule.currentCampaign.branch.geometry.lat
        request.longitude = CampaignDetailsModule.currentCampaign.branch.geometry.lng
      }
    }

    await ajax.post(`/api/v1/agency/contacts/search`, request)
    .then(response => {
      if (response.data == null) {
        response.data = [];
      }
      this.context.commit("setBrowseContactProfiles", response.data);
      if (response.data.length > 0){
        this.context.commit("setBrowseContact", response.data[0]);
      }
      this.setLoadingContacts(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingContacts(false);
    });
 }

  @Action 
  async browseAdvancedContactSearch() {
    
    this.setLoadingContacts(true);
    const request = new ContactProfileSearchRequest();

    request.status = this.contactSearchViewModel.selectedStatus;
    request.isAgreedToMarketing = true;
  
    //Location Types
    request.locationTypeIds = this.contactSearchViewModel.selectedLocationTypes.map(function(locationType: LocationTypeDto) {
      return locationType.id;
    });

    //Positions
    request.positionCodes = this.contactSearchViewModel.selectedPositions.map(function(position: PositionDto) {
      return position.code;
    });

    if (this.currentCampaign.branch !== null) {
      request.distance = this.contactSearchViewModel.selectedDistance.value
      if (request.distance != 0) {
        //Fetch lat and long
        request.latitude = CampaignDetailsModule.currentCampaign.branch.geometry.lat
        request.longitude = CampaignDetailsModule.currentCampaign.branch.geometry.lng
      }
    }

    await ajax.post(`/api/v1/agency/contacts/search`, request)
    .then(response => {
      if (response.data == null) {
        response.data = [];
      }
      this.context.commit("setBrowseContactProfiles", response.data);
      if (response.data.length < 1){
        this.context.commit("setBrowseContact", response.data);
      }
      this.setLoadingContacts(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingContacts(false);
    });
  }

  @Action
  public async getBrowseContact(id: string) {
    this.setLoadingContact(true); 
    await ajax.get(`/api/v1/agency/contacts/${id}/profile`)
    .then(response => {
      this.context.commit("setBrowseContact", response.data);
      this.setLoadingContact(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingContact(false);
    })
  }




  // @Action
  // async getContactSearchOptions() {
  //   this.setLoadingDialog(true);
  //   await ajax.get(`/api/v1/agency/contacts/search-options`)
  //   .then(response => {
  //     this.context.commit("setContactSearchOptions", response.data);
  //     this.setLoadingDialog(false);
  //   })
  //   .catch(error => {
  //     AppModule.handleApiError(error);
  //     this.setLoadingDialog(false);
  //   });
  // }

  @Action 
  async createCampaignContacts(request: CreateCampaignContactsRequest) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/campaigns/${CampaignDetailsModule.currentCampaign.id}/contacts`, request)
    .then(response => {
      //TODO something here that triggers a success message
      this.context.commit("clearBrowseSelectedContactIds");
      //This doesn't really work because the campaign contacts don't have enough data on them
      //Could fix it but for now just refreshing from the calling component
      //this.context.commit("setCampaignContactsFromCreate", response.data.campaignContacts);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action 
  async deleteCampaignContact(id: string) {
    this.setLoadingDialog(true);
    await ajax.delete(`/api/v1/agency/campaigns/${CampaignDetailsModule.currentCampaign.id}/contacts/${id}`)
    .then(response => {
      //TODO something here that triggers a success message
      this.context.commit("removeSelectedCampaignContact", id);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action 
  async getCampaignContacts() {
    this.setLoadingContacts(true);
    await ajax.get(`/api/v1/agency/campaigns/${this.currentCampaign.id}/contacts`)
    .then(response => {
      this.context.commit("setCampaignContacts", response.data);
      this.setLoadingContacts(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingContacts(false);
    });
  }

  @Action
  public async updateSelectedBrowseContact(id: string) {
    const contactProfile = this.browseContactsVM.contactProfiles.find((findContact: SelectableEntity<ContactProfileDto>) => id === findContact.entity.id);
    if (contactProfile) {
      this.context.commit("setBrowseContact", contactProfile.entity); 
    } else {
      this.context.commit("setBrowseContact", null); 
    }
  }

  @Action
  public async addBrowseSelectedContactId(contactId: string){
    this.context.commit("setAddBrowseSelectedContactId", contactId);
  }

  @Action
  public async removeBrowseSelectedContactId(contactId: string){
    this.context.commit("setRemoveBrowseSelectedContactId", contactId);
  }

  // ---------------------------------------------------------------------------
  // Campaign Opportunities (snapshot prospect contacts)
  // ---------------------------------------------------------------------------

  @Action
  async browseOpportunities() {
    this.setLoadingOpportunities(true);
    const vm = this.opportunitySearchViewModel;
    const params = new URLSearchParams();
    // Only Open status, only the active pipeline stages (exclude Won and Lost —
    // those must not be marketed to), and only snapshot opportunity contacts
    // (full prospect contact + no linked Contact). All enforced server-side.
    params.append('status', String(OpportunityStatus.Open));
    [OpportunityStage.New, OpportunityStage.Qualified, OpportunityStage.Proposing, OpportunityStage.Negotiating]
      .forEach(stage => params.append('stage', String(stage)));
    params.append('prospectContactOnly', 'true');
    if (vm.branchId) params.append('branchId', vm.branchId);
    if (vm.deskId) params.append('deskId', vm.deskId);
    if (vm.ownerId) params.append('ownerId', vm.ownerId);
    (vm.workTypes || []).forEach(wt => params.append('workTypes', wt));
    (vm.locationTypeIds || []).forEach(id => params.append('locationTypeId', id));
    await ajax.get(`/api/v1/agency/opportunities?${params.toString()}`)
    .then(response => {
      const data: OpportunityDto[] = response.data || [];
      this.context.commit("setBrowseOpportunityProfiles", data);
      if (data.length > 0) {
        this.context.commit("setBrowseOpportunity", data[0]);
      } else {
        this.context.commit("setBrowseOpportunity", null);
      }
      this.setLoadingOpportunities(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingOpportunities(false);
    });
  }

  @Action
  public async updateSelectedBrowseOpportunity(id: string) {
    const found = this.browseOpportunitiesVM.opportunities.find((o: SelectableEntity<OpportunityDto>) => id === o.entity.id);
    this.context.commit("setBrowseOpportunity", found ? found.entity : null);
  }

  @Action
  public async addBrowseSelectedOpportunityId(opportunityId: string) {
    this.context.commit("setAddBrowseSelectedOpportunityId", opportunityId);
  }

  @Action
  public async removeBrowseSelectedOpportunityId(opportunityId: string) {
    this.context.commit("setRemoveBrowseSelectedOpportunityId", opportunityId);
  }

  @Action
  async createCampaignOpportunities(request: CreateCampaignOpportunitiesRequest) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/campaigns/${this.currentCampaign.id}/opportunities`, request)
    .then(response => {
      this.context.commit("clearBrowseSelectedOpportunityIds");
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async getCampaignOpportunities() {
    this.setLoadingOpportunities(true);
    await ajax.get(`/api/v1/agency/campaigns/${this.currentCampaign.id}/opportunities`)
    .then(response => {
      this.context.commit("setCampaignOpportunities", response.data || []);
      this.setLoadingOpportunities(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingOpportunities(false);
    });
  }

  @Action
  async deleteCampaignOpportunity(id: string) {
    this.setLoadingDialog(true);
    await ajax.delete(`/api/v1/agency/campaigns/${this.currentCampaign.id}/opportunities/${id}`)
    .then(response => {
      this.context.commit("removeSelectedCampaignOpportunity", id);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  cleanState() {
    this.context.commit("resetState");
  }

  @Mutation
  resetState() {

    this.loading = false;
    this.loadingContact = false;
    this.loadingContacts = false;
    this.loadingNotes = true;
    this.loadingDialog = false;
    this.currentCampaign = new CampaignDto();
    this.notes = [];
    this.noteCategories = [];
    this.browseContactsVM = new CampaignBrowseContactsViewModel();
    this.contactSearchViewModel = new ContactSearchViewModel();
    this.campaignContactsVM = new CampaignContactsViewModel();
    this.loadingOpportunities = false;
    this.browseOpportunitiesVM = new CampaignBrowseOpportunitiesViewModel();
    this.opportunitySearchViewModel = new CampaignOpportunitySearchViewModel();
    this.campaignOpportunitiesVM = new CampaignOpportunitiesViewModel();
  }

  @Mutation
  private async setLoading(isLoading: boolean) {
      this.loading = isLoading;
  }

  // @Mutation
  // private async setLoadingContact(isLoading: boolean) {
  //     this.loadingContact = isLoading;
  // } 

  // @Mutation
  // private async setLoadingContacts(isLoading: boolean) {
  //     this.loadingContacts = isLoading;
  // } 

  @Mutation
  private async setLoadingDialog(isLoading: boolean) {
      this.loadingDialog = isLoading;
  } 

  @Mutation
  private async setNoteCategories(noteCategories: NoteCategoryDto[]) {
      this.noteCategories = noteCategories;
  }

  @Mutation
  private async setNotes(notes: NoteDto[]) {
      this.notes = notes;
  }

  @Mutation
  private async setNoteFromCreate(note: NoteDto) {
      this.notes.unshift(note);
  }

  @Mutation
  private async setNoteFromEdit(note: NoteDto) {
      const index = this.notes.findIndex((findNote: NoteDto) => findNote.id === note.id)
      this.notes.splice(index, 1, note);
  }

  @Mutation
  private async setLoadingNotes(isLoading: boolean) {
      this.loadingNotes = isLoading;
  }

  @Mutation
  private async setCurrentCampaign(campaign: CampaignDto) {
      this.currentCampaign = campaign;
      //Also reset the search criteria
      this.browseContactsVM = new CampaignBrowseContactsViewModel();
      this.campaignContactsVM = new CampaignContactsViewModel();
      this.browseOpportunitiesVM = new CampaignBrowseOpportunitiesViewModel();
      this.opportunitySearchViewModel = new CampaignOpportunitySearchViewModel();
      this.campaignOpportunitiesVM = new CampaignOpportunitiesViewModel();
  }

  @Mutation
  private async setLoadingContact(isLoading: boolean) {
      this.loadingContact = isLoading;
  } 

  @Mutation
  private async setLoadingContacts(isLoading: boolean) {
      this.loadingContacts = isLoading;
  } 

  @Mutation
  private async setCurrentCampaignGeneralDetailsFromEdit(campaign: CampaignDto) {
    this.currentCampaign.updatedAt = campaign.updatedAt;
    this.currentCampaign.name = campaign.name;
    this.currentCampaign.ownerId = campaign.ownerId;
    this.currentCampaign.owner = campaign.owner;
    this.currentCampaign.branchId = campaign.branchId;
    this.currentCampaign.branch = campaign.branch;
    this.currentCampaign.deskId = campaign.deskId;
    this.currentCampaign.desk = campaign.desk;
  }

  @Mutation
  private async setCurrentCampaignEmailDetailsFromEdit(campaign: CampaignDto) {
    this.currentCampaign.updatedAt = campaign.updatedAt;
    this.currentCampaign.emailTemplateId = campaign.emailTemplateId;
    this.currentCampaign.emailTemplate = campaign.emailTemplate;
    this.currentCampaign.emailSubject = campaign.emailSubject;
    this.currentCampaign.isEmailOverrideFrom = campaign.isEmailOverrideFrom;
    this.currentCampaign.emailFromFirstName = campaign.emailFromFirstName;
    this.currentCampaign.emailFromLastName = campaign.emailFromLastName;
    this.currentCampaign.emailFromAddress = campaign.emailFromAddress;
    this.currentCampaign.emailMergeField1 = campaign.emailMergeField1;
    this.currentCampaign.emailMergeField2 = campaign.emailMergeField2;
    this.currentCampaign.emailMergeField3 = campaign.emailMergeField3;
    this.currentCampaign.emailMergeField4 = campaign.emailMergeField4;
    this.currentCampaign.emailMergeField5 = campaign.emailMergeField5;
  }

  @Mutation
  private async setCurrentCampaignStatusFromEdit(campaign: CampaignDto) {
    this.currentCampaign.updatedAt = campaign.updatedAt;
    this.currentCampaign.status = campaign.status;
  }

  // @Mutation
  // private async setContactSearchOptions(options: ContactSearchOptionsResponse) {
  //   this.contactSearchViewModel = new ContactSearchViewModel(options.branches, options.positions,  new DistanceViewModel(20, "20"), false);
  // }

  @Mutation
  private async setBrowseContactsVM() {
    this.browseContactsVM.selectedContactIds = [];
    this.browseContactsVM = new CampaignBrowseContactsViewModel();
  }

  @Mutation
  private async setBrowseContact(contact: ContactProfileDto) {
    if (contact) {
      this.browseContactsVM.selectedContactId = contact.id;
      this.browseContactsVM.selectedContact = contact;
    } else {
      this.browseContactsVM.selectedContactId = '';
      this.browseContactsVM.selectedContact = null;
    }
    
  }

  @Mutation
  private async setBrowseContactProfiles(contactProfiles: ContactProfileDto[]) {

    this.browseContactsVM.contactProfiles =  contactProfiles.map(function(contactProfile) {
        return new SelectableEntity<ContactProfileDto>(contactProfile);
      });
  }

  @Mutation
  private async setAddBrowseSelectedContactId(contactId: string) {
    this.browseContactsVM.selectedContactIds.push(contactId);
  }

  @Mutation
  private async setRemoveBrowseSelectedContactId(contactId: string) {
    const index = this.browseContactsVM.selectedContactIds.indexOf(contactId);
    this.browseContactsVM.selectedContactIds.splice(index, 1); 
  }

  @Mutation
  private async clearBrowseSelectedContactIds() {
    //Clear the id list
    this.browseContactsVM.selectedContactIds = [];
  }

  @Mutation
  private async removeSelectedCampaignContact(campaignContactId: string) {
    //Clear the id list
    this.campaignContactsVM.selectedCampaignContact = null;
    const campaignContactIndex = this.campaignContactsVM.campaignContacts.findIndex((findCampaignContact: CampaignContactDto) => findCampaignContact.id === campaignContactId);
    this.campaignContactsVM.campaignContacts.splice(campaignContactIndex, 1); 
  }

  @Mutation
  private async setCampaignContacts(campaignContacts: CampaignContactDto[]) {
    this.campaignContactsVM.campaignContacts = campaignContacts;
    //We also need to update the selected one so that data refreshes as well.
    //TODO: We should really be checking the ID property of the JobContact but setting the base entity ID to '' causes wider issues
    if (this.campaignContactsVM.selectedCampaignContact !== null) {
      const selectedCampaignContact = campaignContacts.find((findCampaignContact: CampaignContactDto) => findCampaignContact.id === this.campaignContactsVM.selectedCampaignContact.id);
      this.campaignContactsVM.selectedCampaignContact = selectedCampaignContact;
    }
  }

  // --- Campaign Opportunities mutations ---

  @Mutation
  private async setLoadingOpportunities(isLoading: boolean) {
    this.loadingOpportunities = isLoading;
  }

  @Mutation
  private async setBrowseOpportunityProfiles(opportunities: OpportunityDto[]) {
    this.browseOpportunitiesVM.opportunities = opportunities.map(function(opportunity) {
      return new SelectableEntity<OpportunityDto>(opportunity);
    });
  }

  @Mutation
  private async setBrowseOpportunity(opportunity: OpportunityDto) {
    if (opportunity) {
      this.browseOpportunitiesVM.selectedOpportunityId = opportunity.id;
      this.browseOpportunitiesVM.selectedOpportunity = opportunity;
    } else {
      this.browseOpportunitiesVM.selectedOpportunityId = '';
      this.browseOpportunitiesVM.selectedOpportunity = null;
    }
  }

  @Mutation
  private async setAddBrowseSelectedOpportunityId(opportunityId: string) {
    this.browseOpportunitiesVM.selectedOpportunityIds.push(opportunityId);
  }

  @Mutation
  private async setRemoveBrowseSelectedOpportunityId(opportunityId: string) {
    const index = this.browseOpportunitiesVM.selectedOpportunityIds.indexOf(opportunityId);
    this.browseOpportunitiesVM.selectedOpportunityIds.splice(index, 1);
  }

  @Mutation
  private async clearBrowseSelectedOpportunityIds() {
    this.browseOpportunitiesVM.selectedOpportunityIds = [];
  }

  @Mutation
  private async setCampaignOpportunities(campaignOpportunities: CampaignOpportunityDto[]) {
    this.campaignOpportunitiesVM.campaignOpportunities = campaignOpportunities;
    if (this.campaignOpportunitiesVM.selectedCampaignOpportunity !== null) {
      const selected = campaignOpportunities.find((c: CampaignOpportunityDto) => c.id === this.campaignOpportunitiesVM.selectedCampaignOpportunity.id);
      this.campaignOpportunitiesVM.selectedCampaignOpportunity = selected;
    }
  }

  @Mutation
  private async removeSelectedCampaignOpportunity(campaignOpportunityId: string) {
    this.campaignOpportunitiesVM.selectedCampaignOpportunity = null;
    const index = this.campaignOpportunitiesVM.campaignOpportunities.findIndex((c: CampaignOpportunityDto) => c.id === campaignOpportunityId);
    this.campaignOpportunitiesVM.campaignOpportunities.splice(index, 1);
  }
}

export const CampaignDetailsModule = getModule(CampaignDetails)

